import { Link } from "react-router-dom";

const highlights = [
  {
    icon: "ri-movie-2-line",
    title: "最新上映速递",
    desc: "同步整理近期院线新片，上映时间、类型与简介一目了然。",
  },
  {
    icon: "ri-bar-chart-2-line",
    title: "多维评分参考",
    desc: "从剧情、演技、画面到音乐，分项评分帮你快速判断是否值得一看。",
  },
  {
    icon: "ri-filter-3-line",
    title: "分类筛选浏览",
    desc: "按类型、年份与评分区间自由筛选，几秒钟锁定你的下一部观影清单。",
  },
  {
    icon: "ri-store-3-line",
    title: "影院动态汇总",
    desc: "地区化的影院排片与场次信息演示，走进影院前先做足功课。",
  },
];

export default function SiteIntro() {
  return (
    <section className="w-full max-w-[1360px] mx-auto px-4 md:px-6 py-14 md:py-16">
      <div className="rounded-lg bg-primary-950 overflow-hidden">
        <div className="grid grid-cols-1 lg:grid-cols-2">
          <div className="p-8 md:p-12">
            <span className="inline-flex items-center gap-1.5 text-xs text-secondary-300 border border-secondary-300/40 rounded-full px-3 py-1">
              <i className="ri-information-line"></i>
              关于最新电影
            </span>
            <h2 className="mt-5 text-2xl md:text-3xl font-heading font-black text-background-50 leading-snug">
              把每一部值得期待的新片
              <br />
              放在你触手可及的地方
            </h2>
            <p className="mt-4 text-sm md:text-[15px] text-background-300 leading-relaxed">
              「最新电影」是一个专注高清电影资讯与上映动态的内容平台。我们围绕最新上映影片，
              提供评分介绍、类型分类浏览以及影院排片动态，帮助影迷用更少的时间，找到更对味的电影。
            </p>
            <div className="flex flex-wrap items-center gap-8 mt-8">
              <div>
                <p className="text-2xl md:text-3xl font-heading font-black text-secondary-400">18+</p>
                <p className="text-xs text-background-400 mt-1">收录影片</p>
              </div>
              <div className="w-px h-10 bg-primary-800"></div>
              <div>
                <p className="text-2xl md:text-3xl font-heading font-black text-secondary-400">9</p>
                <p className="text-xs text-background-400 mt-1">影片类型</p>
              </div>
              <div className="w-px h-10 bg-primary-800"></div>
              <div>
                <p className="text-2xl md:text-3xl font-heading font-black text-secondary-400">24h</p>
                <p className="text-xs text-background-400 mt-1">动态更新</p>
              </div>
            </div>
            <div className="flex flex-wrap gap-3 mt-8">
              <Link
                to="/about"
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-accent-500 text-background-50 text-sm font-semibold hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                了解我们
                <i className="ri-arrow-right-line"></i>
              </Link>
              <Link
                to="/cinema"
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md border border-background-100/30 text-background-100 text-sm font-medium hover:bg-primary-900 transition-colors cursor-pointer whitespace-nowrap"
              >
                影院动态
              </Link>
            </div>
          </div>
          <div className="p-8 md:p-12 bg-primary-900 grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5 content-center">
            {highlights.map((h) => (
              <div key={h.title} className="rounded-lg bg-primary-950/60 p-5">
                <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-accent-500/15 text-accent-400">
                  <i className={`${h.icon} text-xl`}></i>
                </span>
                <h3 className="mt-3.5 text-background-50 font-semibold text-sm">{h.title}</h3>
                <p className="mt-1.5 text-xs text-background-400 leading-relaxed">{h.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}